// extracted by mini-css-extract-plugin
export var container = "_3i-0";
export var error = "_3i-9";
export var label = "_3i-5";
export var light = "_3i-6";
export var md = "_3i-3";
export var sm = "_3i-2";
export var thin = "_3i-8";
export var thinBold = "_3i-7";
export var vertical = "_3i-4";
export var xs = "_3i-1";